export default __webpack_public_path__ + "96c7c40dca7dad6a6780aad15d76b906.png";